// extracted by mini-css-extract-plugin
export default {"List":"MasterDetail_List__dNoXq","SelectList":"MasterDetail_SelectList__OUQZT","Active":"MasterDetail_Active__44jmN"};